import {
  PermissionsOperator,
  PermissionsSpec,
  usePermissionsChecker
} from "core/auth/Permissions";
import { FunctionComponent, PropsWithChildren } from "react";

import { Permission } from "./types/permission.enum";

interface WhenPermissionProps {
  permission: PermissionsSpec;
  operator?: PermissionsOperator;
  else?: JSX.Element;
  customPermissionsCheck?: (userPermissions: Permission[]) => boolean;
}

export const WhenPermission: FunctionComponent<
  PropsWithChildren<WhenPermissionProps>
> = ({
  else: fallback,
  permission,
  operator = "and",
  children,
  customPermissionsCheck
}) => {
  const hasPermission = usePermissionsChecker();
  return hasPermission(permission, operator, customPermissionsCheck) ? (
    <>{children}</>
  ) : (
    fallback ?? null
  );
};
